import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class Step498673Meta extends BaseModel {
  hasPets: boolean | null;
  hasLumpSumGift: boolean | null;
  hasAlternateTutor: boolean | null;

  constructor(model: Partial<Step498673Meta> = {}) {
    super();

    this.hasPets = model.hasPets ?? null;
    this.hasLumpSumGift = model.hasLumpSumGift ?? null;
    this.hasAlternateTutor = model.hasAlternateTutor ?? null;
  }
}
